export default {
  "navbar.about_app": "About APP",
  "navbar.analytics": "Analytics",
  "navbar.asset_dashboard": "Assets",
  "navbar.market_status": "Market",
  "navbar.stock_dashboard": "Investment",
  "navbar.indicators": "Indicators",
};
